<template>
  <div class='container'>
    <h1 class="title">CALIMA Star Analyzer</h1>

    <div id='analyzer-input'>
      <div class='notification is-primary'>
        <p>
          <strong>CALIMA Star</strong> is an Arabic morphological analyzer and generator.
          The analyzer mode determines all the possible out-of-context  combinations of lemmas, morphological features, and diacritizations for undiacritized surface words.
          This demo is based on the work described in Taji et al. (2018). <sup>[1]</sup>
        </p>
      </div>
      <form v-on:keyup.enter.prevent="analyze">

        <div class="columns">
          <!-- Text Input -->
          <div class="column is-full">
            <label class='label'>Input</label>
            <input dir='rtl' lang='ar' class='input ar-input' type='text' placeholder='Write a word or sentence to analyze' v-model='inputText' v-on:keydown.enter.prevent="">
          </div>
        </div>

        <div class="columns">
          <!-- Backoff Mode -->
          <div class="column is-two-fifths">
            <label class='label'>Backoff Mode</label>
            <div class='select is-fullwidth'>
              <select v-model="backoff">
                <option value="NONE">No Backoff</option>
                <option value="ADD_ALL">Backoff to all POS</option>
                <option value="ADD_PROP">Backoff to Proper Nouns</option>
              </select>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="column is-one-fifth is-flex">
            <a class='button is-primary is-fullwidth align-bottom' v-on:click="analyze">Analyze</a>
          </div>
        </div>

      </form>
    </div>

    <div class="error-box has-text-danger is-size-5" v-if="showError">
      <p><div class="fa fa-times"></div> {{ errorMsg }}</p>
    </div>

    <hr v-if="output !== null">

    <div id='analyzer-output' v-if="output !== null">
      <label class='label'>Output</label>
      <div class="output-control">
        <a class="has-text-primary" v-if="!rawView" v-on:click="setRawView(true)">Show Feature-Value Pairs</a>
        <a class="has-text-primary" v-if="rawView" v-on:click="setRawView(false)">Show Simplified Analyses</a>
      </div>
      <div class='box analysis-wrapper'>
        <analyzer-output v-bind:lang="lang" v-bind:outputData='output' v-bind:rawView="rawView"></analyzer-output>
      </div>
    </div>

    <div class="bibliography">
      <p>[1]
        <a href="/static/CalimaStar.pdf" target="_blank">
          Dima Taji, Salam Khalifa, Ossama Obeid, Fadhl Eryani and Nizar Habash.
          <strong>An Arabic Morphological Analyzer and Generator with Copious Features.</strong>
          <i>Workshop on Computational Research in Phonetics, Phonology, and Morphology.
          The Confernece on Empirical Methods in Natural Language Processing (EMNLP 2018), Brussels, Belgium.</i>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import AnalyzerOutput from './Shared/AnalyzerOutput';

export default {
  name: 'Analyzer',
  components: {
    AnalyzerOutput,
  },
  data() {
    return {
      inputText: '',
      backoff: 'NONE',
      match: 'ALL',
      output: null,
      rawView: false,
      lang: 'en',
      errorMsg: 'An error occurred during analysis.',
      showError: false,
    };
  },

  methods: {
    analyze() {
      this.output = null;
      this.showError = false;

      this.inputText = this.inputText.trim();

      if (this.inputText.length === 0) {
        // TODO: throw an error
        return;
      }

      this.$http.get(`${API_URL}/analyze/?sent=${encodeURIComponent(this.inputText)}&backoff=${encodeURIComponent(this.backoff)}&match=${encodeURIComponent(this.match)}`)
        .then((response) => {
          this.output = response.body;
        })
        .catch((error) => {
          this.showError = true;
          // eslint-disable-next-line
          console.log(error);
        });
    },
    setRawView(v) {
      this.rawView = v;
    },
  },

  watch: {},

  mounted() {},
};
</script>

<style lang='scss' scoped>

.container {
  padding-left: 1rem;
  padding-right: 1rem;
}

label.checkbox {
  margin-right: 1rem;
}

.analysis-wrapper {
  width: 100%;
  height: 25rem;
  overflow: scroll;
}

.ar-input {
  font-size: 1.3em;
}

.align-bottom {
  margin-top: auto;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Analyzer.vue